import {useState, useEffect} from 'react';
import {v4 as uuidv4} from 'uuid';
import {useChatbotMessages} from '@/hooks/help';
import {useDisableRefresh} from '@/hooks/common/useDisableRefresh';
import {removeCookie, setCookie, getCookie} from '@/utils/main';
import {sendHelpClickLog} from '@/utils/help/log';
import {HELP_LOG} from '@/constants/help';
import {CHATBOT_SESSION_ID} from '@/constants/help/chatbot';
import ChatbotHeader from './ChatbotHeader';
import ChatbotMessages from './ChatbotMessages';
import ChatbotInputArea from './ChatbotInputArea';
import CloseLayer from './CloseLayer';
import styles from './Chatbot.module.scss';

const Chatbot = () => {
  useEffect(() => {
    // 멀티턴(이전 대화에 기반한 지속적 대화)기능을 위한 세션 아이디
    // 새로고침, 재접근 시 초기화
    const sessionId = uuidv4();

    const setSessionId = () => {
      if (getCookie(CHATBOT_SESSION_ID) === sessionId) {
        return;
      }
      setCookie(CHATBOT_SESSION_ID, sessionId);
    };
    const removeSessionId = () => {
      removeCookie(CHATBOT_SESSION_ID);
    };

    setSessionId();
    window.addEventListener('focus', setSessionId);
    window.addEventListener('beforeunload', removeSessionId);
    return () => {
      window.removeEventListener('focus', setSessionId);
      window.removeEventListener('beforeunload', removeSessionId);
    };
  }, []);

  // 챗봇 이탈 방지 레이어 노출
  const [isLayerOpened, setIsLayerOpened] = useState(false);
  const handleHeaderCloseButton = () => {
    setIsLayerOpened(true);
    sendHelpClickLog(HELP_LOG.CODE_TYPE.CHATBOT, {
      buttonType: HELP_LOG.BUTTON_TYPE.CHATBOT_EXIT_ICON,
    });
  };

  const [hasHeaderShadow, setHasHeaderShadow] = useState(false);

  const {messages, handleSend, isPending} = useChatbotMessages();

  // 앱에서 pull to refresh 기능 off
  useDisableRefresh();

  return (
    <div className={styles.wrapper}>
      <ChatbotHeader
        handleCloseButton={handleHeaderCloseButton}
        hasHeaderShadow={hasHeaderShadow}
      />

      <ChatbotMessages
        messages={messages}
        handleSend={handleSend}
        isPending={isPending}
        setHasHeaderShadow={setHasHeaderShadow}
      />

      <ChatbotInputArea handleSend={handleSend} />

      {isLayerOpened && (
        <CloseLayer closeLayer={() => setIsLayerOpened(false)} />
      )}
    </div>
  );
};

export default Chatbot;
